import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class Panel extends PureComponent {
  render() {
    const { children, className, access, ...others } = this.props;
    const cls = classNames({
      "weui-panel": true,
      "weui-panel_access": access
    }, className);

    return (
      <div className={ cls } { ...others }>{ children }</div>
    );
  }
}
